const TB_BREAK_POINT = 900;
const TB_DECREMENT = 0.8;

const AGENT_TYPES = [
  {
    name: 'agent_1',
    value: 'agent_1',
  },
  {
    name: 'agent_2',
    value: 'agent_2',
  },
  {
    name: 'agent_3',
    value: 'agent_3',
  },
  {
    name: 'agent_4',
    value: 'agent_4',
  },
];

const AGENT_TYPES_FOR_POPULATION = [
  {
    name: 'all agent types',
    value: 'all',
  },
  ...AGENT_TYPES,
];

const ANIMATION_MAP = {
  agent_1: [
    { className: 'buruburu', soundName: 'AGENT_1_BURUBURU' },
    { className: 'furufuru', soundName: 'AGENT_1_FURUFURU' },
    { className: 'patsun', soundName: 'AGENT_1_PATSUN' },
    { className: 'scale', soundName: 'AGENT_1_SCALE' },
    { className: 'shake', soundName: 'AGENT_1_SHAKE' },
    { className: 'yureru-hard', soundName: 'AGENT_1_YURERU_S' },
  ],
  agent_2: [
    { className: 'buruburu', soundName: 'AGENT_2_BURUBURU' },
    { className: 'furufuru', soundName: 'AGENT_2_FURUFURU' },
    { className: 'patsun', soundName: 'AGENT_2_PATSUN' },
    { className: 'scale', soundName: 'AGENT_2_SCALE' },
    { className: 'shake', soundName: 'AGENT_2_SHAKE' },
    { className: 'yureru-hard', soundName: 'AGENT_2_YURERU_S' },
  ],
  agent_3: [
    { className: 'buruburu', soundName: 'AGENT_3_BURUBURU' },
    { className: 'yureru-roll', soundName: 'AGENT_3_YURERU_ROLL' },
  ],
  agent_4: [
    { className: 'buruburu', soundName: 'AGENT_4_BURUBURU' },
    { className: 'furufuru', soundName: 'AGENT_4_FURUFURU' },
  ],
};

const END_LIFE_ANIMATION = 'end-life';

const BASE_SETTING = {
  N: 20, // 1 of agents
  L: 128, // world size
  worldWidth: window.innerWidth,
  worldHeight: window.innerHeight,
  noiseSpeed: 0.25, // variation in individuals' speeds
  epsilon: 0.2, // angular increment
};

const ECLIPSE_SCHEDULE = ['00', '15', '30', '45', '60'];

const TYPE_MAP = [
  {
    name: 'agent_1',
    max: 30,
  },
  {
    name: 'agent_2',
    max: 25,
  },
  {
    name: 'agent_3',
    max: 8,
  },
  {
    name: 'agent_4',
    max: 6,
  },
];

// 下のクラスのagentがどの割合で生息していたら、誕生するのか
const BIRTH_CONDITION = {
  agent_1: {
    min: null,
    max: null,
  },
  agent_2: {
    min: 0.6,
    max: 0.8,
  },
  agent_3: {
    min: 0.6,
    max: 0.8,
  },
  agent_4: {
    min: 0.3,
    max: 0.9,
  },
};

const sizeMap = (() => {
  if (window.innerWidth < TB_BREAK_POINT) {
    return {
      agent_1: 20 * TB_DECREMENT,
      agent_2: 20 * TB_DECREMENT,
      agent_3: 35 * TB_DECREMENT,
      agent_4: 60 * TB_DECREMENT,
    };
  }

  return {
    agent_1: 20,
    agent_2: 20,
    agent_3: 35,
    agent_4: 60,
  };
})();

// agentのサイズ
const AGENT_SIZE = {
  agent_1: {
    width: sizeMap.agent_1,
    height: sizeMap.agent_1,
  },
  agent_2: {
    width: sizeMap.agent_2,
    height: sizeMap.agent_2,
  },
  agent_3: {
    width: sizeMap.agent_3,
    height: sizeMap.agent_3,
  },
  agent_4: {
    width: sizeMap.agent_4,
    height: sizeMap.agent_4,
  },
};

const LIFE_DEATH_RATIOS = {
  agent_1: {
    birthRate: 50,
    deathRate: 50,
  },
  agent_2: {
    birthRate: 50,
    deathRate: 50,
  },
  agent_3: {
    birthRate: 50,
    deathRate: 50,
  },
  agent_4: {
    birthRate: 50,
    deathRate: 50,
  },
};

const gainValueMap = (() => {
  if (window.innerWidth < TB_BREAK_POINT) {
    return {
      agent_1: 0.25,
      agent_2: 0.25,
      agent_3: 0.3,
      agent_4: 0.5,
    };
  }

  return {
    agent_1: 0.4,
    agent_2: 0.4,
    agent_3: 0.6,
    agent_4: 0.8,
  };
})();

// volume制御できるようになったのでちょっと強めに
const GAIN_VALUE_MAP = {
  agent_1: gainValueMap.agent_1,
  agent_2: gainValueMap.agent_2,
  agent_3: gainValueMap.agent_3,
  agent_4: gainValueMap.agent_4,
};

// 全部真っ白にする（一時的に）
const BACKGROUND_COLOR_SCHEDULE = [
  {
    time: '05:00:00',
    backgroundColor: {
      r: 255,
      g: 255,
      b: 255,
    },
  },
  {
    time: '11:00:00',
    backgroundColor: {
      r: 255,
      g: 252,
      b: 241,
    },
  },
  {
    time: '17:00:00',
    backgroundColor: {
      r: 255,
      g: 252,
      b: 241,
    },
  },
  {
    time: '23:00:00',
    backgroundColor: {
      r: 255,
      g: 255,
      b: 255,
    },
  },
];

const BACKGROUND_COLOR_PATTERN = [
  {
    soundName: 'ENV_SIX',
    backgroundColor: {
      r: 255,
      g: 255,
      b: 255,
    },
  },
  {
    soundName: 'ENV_SEVEN',
    backgroundColor: {
      r: 255,
      g: 255,
      b: 255,
    },
  },
  {
    soundName: 'ENV_EIGHT',
    backgroundColor: {
      r: 255,
      g: 252,
      b: 241,
    },
  },
];

const SUN_RADIUS = (() => {
  const r = 123;

  if (window.innerWidth < TB_BREAK_POINT) {
    return r * (6 / 10);
  }

  return r;
})();

const MOON_RADIUS = (() => {
  const r = 120;

  if (window.innerWidth < TB_BREAK_POINT) {
    return r * (6 / 10);
  }

  return r;
})();

export default {
  TB_BREAK_POINT,
  AGENT_TYPES,
  AGENT_TYPES_FOR_POPULATION,
  ANIMATION_MAP,
  END_LIFE_ANIMATION,
  BASE_SETTING,
  ECLIPSE_SCHEDULE,
  TYPE_MAP,
  BIRTH_CONDITION,
  AGENT_SIZE,
  LIFE_DEATH_RATIOS,
  GAIN_VALUE_MAP,
  BACKGROUND_COLOR_SCHEDULE,
  BACKGROUND_COLOR_PATTERN,
  SUN_RADIUS,
  MOON_RADIUS,
};
